import { API_ROUTES } from '@config/routes';
import api from './api';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface PackageLineItem {
  id: string;
  name: string;
  description: string;
  quantity: number;
  price: number;
  category: string;
}

export interface Package {
  id: string;
  name: string;
  items: PackageLineItem[];
  isAddon?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

// ── Service ───────────────────────────────────────────────────────────────────

export const packageService = {
  getPackages: (): Promise<Package[]> => api.get<Package[]>(API_ROUTES.PACKAGES.BASE),

  createPackage: (data: Omit<Package, 'id' | 'createdAt' | 'updatedAt'>): Promise<Package> =>
    api.post<Package>(API_ROUTES.PACKAGES.BASE, data),

  updatePackage: (id: string, data: Partial<Omit<Package, 'id'>>): Promise<Package> =>
    api.put<Package>(API_ROUTES.PACKAGES.BY_ID(id), data),

  deletePackage: (id: string): Promise<void> => api.delete<void>(API_ROUTES.PACKAGES.BY_ID(id)),
};
